module.exports = {
	config: {
		projectTermJobMode: false, // if true the summary will be determined according to the projectTermJobs instead of its own field: this.model.dataJSON. furthermore, some buttons won't show.
	},

	model: {
		fieldConfigHasBeenInitialized: false, // has config been initialized?

		dataJSON: {},

		onDecisionCallback: null, // stores the onDecision-callback which may be given as a parameter of decisionOptions.
		openActionName: null, // name of the action used to open the select-modal.

		entityData: null, // parentForms entityData (just a shortcut)
		entityID: null, // parentForms entityID (just a shortcut)

		config: {
			// GUI
			showSummary: true, // should summary be shown
			supportDeleteSelection: true, // show inline button to delete all assignments?
		}
	},

	events: {
		open: {
			type: 'click',
			async action(event) {
				event.preventDefault()
				event.stopImmediatePropagation()

				const self = event.data.component
				const $target = $(event.target)
				const $realTarget = $target.closest('button')

				if($realTarget.length > 0) {
					const fieldType = $realTarget.data('fieldType')
					const mode = $realTarget.data('buttonMode')
					if(fieldType === 'assign'){
						if(mode === 'empty'){
							self.emptyAssignedElements()
						} else {
							const $potentialParentModal = $target.closest('.base_modal_modal')
							const overruleCKEditor = ($potentialParentModal.length > 0 && $potentialParentModal.hasClass('overruleCKEditor'))

							self.open(undefined, undefined, undefined, undefined, overruleCKEditor)
						}
					} else if(fieldType === 'showList') {
						self.showList_projectTermJobs()
					} else {
						console.error(`unknown fieldTypeFound: ${fieldType}`)
					}
				}
			}
		}
	},

	methods: {
		sanitizeResources(storage){
			this.initModel(storage)
		},

		initFieldConfig(){
			if(this.model.fieldConfigHasBeenInitialized){
				return
			}
			this.model.fieldConfigHasBeenInitialized = true

			const fieldConfig = this.model.config || {}

			if(fieldConfig.showSummary === undefined){
				fieldConfig.showSummary = true
			}
			if(fieldConfig.showOnRegistrationMandatory === undefined){
				fieldConfig.showOnRegistrationMandatory = true
			}
			// those are not implemented yet. all flags fall back to showOnRegistration at the moment
			if(fieldConfig.showOnCustomerOrderMandatory === undefined){
				fieldConfig.showOnCustomerOrderMandatory = false
			}
			if(fieldConfig.showOnEmployeeJobSelectionMandatory === undefined){
				fieldConfig.showOnEmployeeJobSelectionMandatory = false
			}
			if(fieldConfig.showOnOfficeEmployeeJobSelectionMandatory === undefined){
				fieldConfig.showOnOfficeEmployeeJobSelectionMandatory = false
			}
		},

		initModel: function(storage){
			storage = storage || globalThis.storage
			this.initFieldConfig()

			let parentForm;
			this.parent(p => parentForm = p)

			const data = this.model.entityData = ((parentForm || {}).resourceData || {}).data || {}
			const attributes = data.attributes || {}
			const entityID = this.model.entityID = attributes[data.primaryKey || 'id']
			this.config.projectTermJobMode = !!entityID

			// extend if necessary
		},

		prepareSummary: function(){
			const fieldConfig = this.model.config || {}
			if(!fieldConfig.showSummary) {
				return
			}

			// collect jobs via bo_projectTermJobs if necessary
			const jobs = {}
			if(this.config.projectTermJobMode){
				let parentForm;
				this.parent(p => parentForm = p)

				if(parentForm){
					for(const ptj of ((((parentForm.resourceData || {}).data || {}).children || {}).bo_projectTermJobs || {}).data || []){
						const j = (((((ptj || {}).children || {}).bo_jobs || {}).data || {}).attributes || {})
						const projectTermJobID = (ptj.attributes || {}).projectTermJobID
						const jobID = j.jobID || '~'

						if(!projectTermJobID){
							continue
						}

						const job = jobs[jobID] = jobs[jobID] || {
							code: j.code || '???',
							title: j.title || '',
							value: 0,
						}
						job.value++
					}
				}
			}

			const summary = this.model.summaryOfAssignedElements = []
			const entities = Object.values(this.model.dataJSON || jobs || {})
				.sort((a, b) => {
					if(a.code < b.code) return -1;
					if(a.code > b.code) return 1;
					return 0;
				})

			for(const entity of entities){
				if(entity.value > 0){
					summary.push(`${entity.value} x ${entity.title || entity.code}`)
				}
			}
		},

		open: function(previouslyAssinedTags, onDecisionCallback, overrideAction, enhancedResourceRegisterContent, overruleCKEditor = false){
			const fieldConfig = this.model.config || {}

			this.model.onDecisionCallback 	= onDecisionCallback
			const actionName 		= overrideAction || 'showSelect_nrOfElementsPerJob'
			const actionID 			= this.model.openActionName = actionName + '_inEffect'

			this.performAndStoreAction(
				actionID,
				this.prepareAction(
					actionName,
					undefined,
					{
						selectedEntities: {
							dataJSON: this.model.dataJSON || {},
						},
						fieldConfig,
					}
				),
				true
			)
		},

		// prevent the select-modal from being reopened before refreshes are necessary. e.g., summary update necessary after assignment.
		async close(){
			await this.destroyAction(this.model.openActionName)
		},

		emptyAssignedElements: function(){
			this.model.dataJSON = {}
			this.triggerClosest('onChildChanged', {
				fieldCode: this.model.fieldCode,
				value: {}
			})

			this.refresh(false)
		},

		onBeforeRender(){
			this.prepareSummary()
		},



		///// SPECIALS
		async showList_projectTermJobs(){
			if(!this.config.projectTermJobMode) return;

			// prepare resourceRegister
			const entityData = this.model.entityData || {}
			const entityID = this.model.entityID || 0
			const resourceRegister = {}

			if(!entityID){
				return console.error('MISSING ENTITY ID')
			}

			resourceRegister.parentEntity = {
				entityID,
				entityData,
				primaryKey: entityData.primaryKey,
			}
			resourceRegister.parentEntityForProperties = {
				resourceID: entityID,
			}
			resourceRegister.parentEntityForTable = {
				baseFilters: {
					[entityData.primaryKey]: entityID
				}
			}
			resourceRegister.parentEntityForStatus = {
				baseFilters: {
					[entityData.primaryKey]: entityID,
					hindersCustomerOrder: this.scope === 'customers',
				}
			}

			// show list of projectTermJobs
			try {
				await this.performAndStoreAction(
					'showList_projectTermJobs_inEffect',
					this.prepareAction(
						'showList_projectTermJobs',
						undefined,
						resourceRegister,
					),
					true,
				)
			} catch (error) {
				console.error(error)
			}
		},
	},

	hooks: {
		async onDecision($element, options){
			const fieldConfig = this.model.config || {}

			let modal
			if(options.decisionComponent.hasClass('base_modal_modal')){
				modal = options.decisionComponent
			}

			switch(options.decisionType){
				case 'submit':
					if(this.config.projectTermJobMode) break;
					this.model.dataJSON = this.model.dataJSON || {}

					let nrOfElementsPerJob
					options.decisionComponent.find('templates_core_form_fields_selectNrOfElementsPerJob', c => nrOfElementsPerJob = c)

					this.model.dataJSON = nrOfElementsPerJob.value()

					if(modal){
						await modal.hide()
						modal = null
					}

					await this.triggerClosest('onChildChanged', {
						fieldCode: 	this.model.fieldCode,
						value: 		this.model.dataJSON,
					})
					this.refresh(false)

					break;

				case 'cancel':

					if(!this.config.projectTermJobMode || !fieldConfig.showSummary) break;

					// refresh summary in case projectTermJobs get edited after initial creation.
					// the summary gets its data from its main-parentForm.
					if(modal){
						await modal.hide()
						modal = null
					}

					let parentForm
					this.furthest('base_form_form', undefined, p => parentForm = p)
					if(parentForm){
						await parentForm.refresh()
					}
					break;
			}

			if(modal){
				await modal.hide()
			}
		},
	},
}
